import React from "react";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin"
import Prose from "../utility/prose";

const PavilionRentalCalendar = () => {
  return (
    <div className={`m-auto md:w-full mb-14 leading-none`}>
      <div className="iframe-4by3-wrapper iframe-calendar-wrapper">
        <iframe className="iframe-rounded iframe-calendar" src="https://outlook.office365.com/owa/calendar/3b6f643cee924c62a6f9e1c29a2defca@bridgestonemud.com/2b9488cad78a460ca0bd14a69a49458713259144834452611946/calendar.html" style={{borderWidth:0}} frameborder="0" scrolling="yes"></iframe>
      </div>
    </div>
  )
}

export default PavilionRentalCalendar

